<template>
  <div>
    <el-form label-position="right"
      label-width="100px"
      :model="form"
      :rules="rules"
      ref="form">
      <el-form-item label="手机号码">
        <p>{{userPhone}}</p>
      </el-form-item>
      <el-form-item label="短信验证码"
        prop="oldCode">
        <el-input v-model="form.oldCode"
          style="width: 50%"
          placeholder="请输入您收到的短信验证码">
        </el-input>
        <el-button @click.prevent="sendSMSCode('self')"
          :disabled="!show"
          :loading="oldLoading"
          style="margin-left: 10px">
          <span v-show="show">获取短信验证码</span>
          <span v-show="!show"
            class="count">{{ count }} s</span>
        </el-button>
      </el-form-item>
      <el-form-item label="新手机号码"
        prop="phone">
        <el-input v-model="form.phone"
          style="width: 50%"
          placeholder="请输入新的手机号码">
        </el-input>
      </el-form-item>
      <el-form-item label="短信验证码"
        prop="newCode">
        <el-input v-model="form.newCode"
          style="width: 50%"
          placeholder="请输入您收到的短信验证码">
        </el-input>
        <el-button @click.prevent="sendSMSCode('newPhone')"
          :loading="newLoading"
          :disabled="!newShow"
          style="margin-left: 10px">
          <span v-show="newShow">获取短信验证码</span>
          <span v-show="!newShow"
            class="count">{{ newCount }} s</span>
        </el-button>
      </el-form-item>
    </el-form>
    <div style="text-align: right">
      <el-button @click="backAccount">返 回</el-button>
      <el-button type="primary"
        :loading="loadingBtn"
        @click="submitPassword('form')">确认修改</el-button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import {
  handleLoginErrorToast,
  handleLoginSuccessToast,
} from "@/assets/utils/handleData.js";
export default {
  data() {
    return {
      userPhone: "",
      oldLoading: false,
      newLoading: false,
      loadingBtn: false,
      form: {
        oldCode: "",
        phone: "",
        newCode: "",
      },
      rules: {
        oldCode: [
          {
            required: true,
            message: "原手机号验证码不能为空",
            trigger: "blur",
          },
        ],
        newCode: [
          {
            required: true,
            message: "新手机号验证码不能为空",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern:
              /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/,
            message: "您输入的手机号码格式有误，请重新输入",
            trigger: "change",
          },
        ],
      },
      count: null,
      show: true,
      timer: null,
      newCount: null,
      newShow: true,
      newTimer: null,
    };
  },
  methods: {
    backAccount() {
      this.$parent.showCom = "Account";
    },
    submitPassword(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await api.loginModifyPhone({
            currentPhoneSmsCode: this.form.oldCode,
            newPhone: this.form.phone,
            newPhoneSmsCode: this.form.newCode,
          });
          if (res && res.status == 200) {
            this.loadingBtn = false;
            if (res.data.code == 200) {
              if (handleLoginSuccessToast(res.data.data) !== "") {
                this.$message.success("修改手机号码成功,请重新登录！");
                setTimeout(() => {
                  this.$store.dispatch("logout");
                  this.$store.commit("SET_ROUTE", []);
                }, 1000);
              } else {
                this.$message.error(handleLoginErrorToast(res.data.data));
              }
            }
          }
        } else {
          return false;
        }
      });
    },
    sendSMSCode(type) {
      if (type === "self") {
        this.oldLoading = true;
        this.sendCodeBySelf();
      } else {
        this.$refs.form.validateField("phone", (errorMessage) => {
          if (errorMessage === "") {
            this.newLoading = true;
            this.sendCodeByNewPhone();
          }
        });
      }
    },

    async sendCodeBySelf() {
      let res = await api.loginSendSMSCodeBySelf({});
      if (res && res.status == 200) {
        this.oldLoading = false;
        if (res.data.code == 200) {
          if (handleLoginSuccessToast(res.data.data) !== "") {
            this.$message.success("原手机号码发送验证码成功");
            this.getCode("timer", "count", "show");
          } else {
            this.$message.error(handleLoginErrorToast(res.data.data));
          }
        }
      }
    },
    async sendCodeByNewPhone() {
      let res = await api.loginSendSMSCodeByNewPhone({
        phone: this.form.phone,
      });
      if (res && res.status == 200) {
        this.newLoading = false;
        if (res.data.code == 200) {
          if (handleLoginSuccessToast(res.data.data) !== "") {
            this.$message.success("新手机号码发送验证码成功");
            this.getCode("newTimer", "newCount", "newShow");
          } else {
            this.$message.error(handleLoginErrorToast(res.data.data));
          }
        }
      }
    },
    getCode(timer, count, show) {
      if (!this[timer]) {
        this[count] = 60;
        this[show] = false;
        this[timer] = setInterval(() => {
          if (this[count] > 0 && this[count] <= 60) {
            this[count]--;
          } else {
            this[show] = true;
            clearInterval(this[timer]);
            this[timer] = null;
          }
        }, 1000);
      }
    },
  },
  created() {
    this.userPhone = JSON.parse(
      window.sessionStorage.getItem("userInfo")
    ).phone;
  },
};
</script>

<style>
</style>